import colours from './colours';

export const light = {
  colours: {
    page_text_colour_pri: colours.white,
    page_text_colour_alt: colours.grey_50,
    page_link_colour: colours.blue_50,
    page_link_colour_active: colours.vivid_cyan,
    tab_text_pri: colours.white,
    tab_text_pri_active: colours.white,
    tab_bottom_separator: colours.white
  }
};
